import { JudgeRecord } from '@/domain/entities/judge/judgeRecord'
import { JudgeRepository } from '@/domain/repositories/judge/JudgeRepository'

export class GetRecentJudgeResultListUseCase {
  constructor(private judgeRepository: JudgeRepository) {}

  async getRecentJudgeResultList(): Promise<JudgeRecord[]> {
    try {
      const data = await this.judgeRepository.getRecentJudgeResultList()
      return data
    } catch (error) {
      console.error(
        `Error in GetRecentJudgeresultListUseCase: ${error instanceof Error ? error.message : String(error)}`
      )
      throw error
    }
  }
}
